import styled from 'styled-components';

export const Label = styled.span`
  margin-left: var(--xs-padding-horizontal);
  margin-right: var(--xxs-padding-horizontal);
`;

// The shared ActionSelect has no disabled mode of its own, so a disabled
// instance (e.g. in a loading skeleton) is wrapped to block interaction and
// dim it like the other disabled controls.
export const Disabled = styled.div`
  pointer-events: none;
  opacity: 0.5;
`;
